import type { ProcurementStaleItem } from './types'

export function StaleItemsTable({
  items,
  onRowClick,
}: {
  items: ProcurementStaleItem[]
  onRowClick?: (item: ProcurementStaleItem) => void
}) {
  return (
    <div className="bg-white rounded-2xl border border-gray-200 p-4 h-full">
      <div className="text-sm text-gray-500 mb-3">Хвосты без движения</div>

      {items.length === 0 ? (
        <p className="text-sm text-gray-400 py-4">Всё в работе, хвостов нет</p>
      ) : (
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead>
              <tr className="text-xs text-gray-500">
                <th className="text-left font-normal pb-2">Парт-номер</th>
                <th className="text-left font-normal pb-2">Заявка</th>
                <th className="text-right font-normal pb-2">Дней</th>
                <th className="text-right font-normal pb-2">Действие</th>
              </tr>
            </thead>
            <tbody>
              {items.map((i) => (
                <tr
                  key={i.itemId}
                  onClick={() => onRowClick?.(i)}
                  className={`border-t border-gray-100 ${
                    onRowClick ? 'cursor-pointer hover:bg-gray-50' : ''
                  }`}
                >
                  <td className="py-2 font-mono text-xs text-gray-900">{i.partNumber}</td>
                  <td className="py-2 text-gray-600 tabular-nums">{i.requestNumber ?? '—'}</td>
                  <td className="py-2 text-right tabular-nums text-amber-700 font-medium">
                    {i.daysInactive}
                  </td>
                  <td className="py-2 text-right text-xs text-brand-600">Напомнить →</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  )
}
